module.exports = __webpack_public_path__ + "img/Cake-Cut.0f8265f1.jpeg";